<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V6PfjM/tc-custom/9781780100623.jpg?1705378738483" alt="This image is the cover for the book Cuckoo's Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cuckoo's Child
      </h1>
      <p class="bookDescription body article font2">
        <b>A young woman comes of age and discovers her hidden past in this gripping historical mystery set in the north of England.</b><br/>  <br/> England, 1909. When twenty-one-year-old Laura Harcourt accepts a position in Wainthorpe, a small Yorkshire town, to catalog books in an old manor house owned by wealthy local Ainsley Beaumont, she does not dream that it will change her life forever. But she arrives to find the Beaumont family still torn apart by the death of Ainsley’s son in a disastrous fire twenty years past. Worse still, the damaged wing of the house remains untouched. When a dead body surfaces in the water at Beaumont’s mill, long-buried secrets soon follow—including Laura’s unexpected connection to the Beaumont family. Rendered in exquisite period detail, <i>Cuckoo’s Child</i> is a moving, suspenseful mystery of love, lies, and murder.<br/>  <br/> “Eccles’ latest enjoyably blends historical romance and suspenseful murder mystery in a keep-’em-guessing plot with revealing insights into English society at the time and authentic period ambience. Entertaining reading for fans of British historicals.” <i>—Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marjorie Eccles
      </h2>
      
      <p class="authorDescription body article">Marjorie Eccles was born in Yorkshire and spent much of her childhood there and on the Northumbrian coast. She is the recipient of the Agatha Christie Short Story Styles Award. A keen gardener, she lives with her husband in Hertfordshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?95d8a9a0